import { createTheme } from '@mui/material';

export const authHeadingStyles = {
  fontSize: { xs: 28, sm: 32, md: 36 },
  fontFamily: 'Montserrat, Roboto, Helvetica, Arial, sans-serif',
  lineHeight: { xs: 1.15, sm: 1.2 },
  letterSpacing: '-0.02em',
  textWrap: 'balance',
  maxWidth: { xs: '12ch', sm: '15ch', md: '18ch' },
  mx: 'auto',
};

export const authSubtextStyles = {
  fontSize: { xs: 14, sm: 16 },
  lineHeight: { xs: 1.5, sm: 1.6 },
  textWrap: 'pretty',
  maxWidth: { xs: '32ch', sm: '42ch', md: '48ch' },
  mx: 'auto',
};

const signupTheme = createTheme({
  palette: {
    primary: {
      main: '#5a8f11',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2b4b86',
    },
    background: {
      default: '#fefefe',
      paper: '#ffffff',
    },
    text: {
      primary: '#1c1b1f',
      secondary: '#625b71',
    },
    error: {
      main: '#ba1a1a',
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h4: {
      fontFamily: ['Montserrat', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      textWrap: 'balance',
    },
    h5: {
      fontFamily: ['Montserrat', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      textWrap: 'balance',
    },
    subtitle1: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        variant: 'outlined',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          minHeight: 48,
          borderRadius: 12,
          [theme.breakpoints.up('sm')]: {
            minHeight: 52,
          },
          '&.MuiButton-containedPrimary': {
            color: '#ffffff',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#4f8506',
              color: '#ffffff',
              boxShadow: 'none',
            },
          },
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: '#ffffff',
          minHeight: 52,
          [theme.breakpoints.up('sm')]: {
            minHeight: 56,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E4E6F1',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E4E6F1',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#5a8f11',
            borderWidth: 2,
          },
        }),
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 6,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#1c1b1f',
        },
      },
    },
  },
});

export default signupTheme;
